<template>
    <div id="placement-preference-form">
        <v-card>
            <v-card-title>
                <v-icon left :color="kingsGold">mdi-information</v-icon>General Information
            </v-card-title>
            <v-alert v-if="alert" :color="dangerColor" class="mr-3 ml-3 mb-0" dense icon="mdi-alert-circle" text
                prominent>
                There are one or more required form fields that are empty. Please verify that all required form fields
                are filled in.
            </v-alert>
            <v-card-text>
                <v-form ref="placementPreferenceForm" v-model="valid" lazy-validation>
                    <v-container class="px-0" fluid>
                        <v-card-subtitle class="pb-0 px-0">
                            <v-icon :color="kingsGold" left>mdi-medical-bag</v-icon>Standard First Aid Training
                            <br>
                            You are required to complete Standard First Aid training (Typically a 2 day course) prior to
                            training week and
                            provide proof of certification. King’s does not reimburse the cost of the training.
                        </v-card-subtitle>
                        <v-row>
                            <v-col cols="12" lg="4">
                                <v-text-field v-model="applicant.firstAidTrainingInitials"
                                    label="I understand (please initial)" prepend-icon="mdi-draw"
                                    :rules="firstAidTrainingInitialsRules" required>
                                </v-text-field>
                            </v-col>
                        </v-row>
                        <v-card-subtitle class="pb-0 px-0">
                            <v-icon :color="kingsGold" left>mdi-card-account-details</v-icon>Canadian Social Insurance
                            Number
                            <br>
                            You are required to have a Canadian Social Insurance Number card (SIN) by the end of August
                            for payroll
                            purposes.
                        </v-card-subtitle>
                        <v-row>
                            <v-col cols="12" lg="4">
                                <v-text-field v-model="applicant.sinCardInitials" label="I understand (please initial)"
                                    prepend-icon="mdi-draw" :rules="sinCardInitialsRules" required>
                                </v-text-field>
                            </v-col>
                        </v-row>
                        <v-card-subtitle class="pb-0 px-0">
                            <v-icon :color="kingsGold" left>mdi-allergy</v-icon>Food/Allergies Concern(s)
                            <br>
                            Please advise us of any other allergies, food concerns or circumstances that you feel we
                            should know about when planning RA training week.
                        </v-card-subtitle>
                        <v-row>
                            <v-col cols="12">
                                <v-checkbox v-model="applicant.allergiesType" dense hide-details label="Vegetarian"
                                    multiple value="Vegetarian">
                                </v-checkbox>
                                <v-checkbox v-model="applicant.allergiesType" dense hide-details label="Vegan" multiple
                                    value="Vegan">
                                </v-checkbox>
                                <v-checkbox v-model="applicant.allergiesType" dense hide-details
                                    label="Gluten Intolerant" multiple value="Gluten Intolerant">
                                </v-checkbox>
                                <v-checkbox v-model="applicant.allergiesType" dense hide-details
                                    label="Lactose Intolerant" multiple value="Lactose Intolerant">
                                </v-checkbox>
                                <v-checkbox v-model="applicant.allergiesType" dense hide-details label="Food Allergies"
                                    multiple value="Food Allergies">
                                </v-checkbox>
                            </v-col>
                            <v-col cols="12" class="pt-4">
                                <v-textarea v-model="applicant.allergiesConcern" auto-grow hide-details
                                    label="Food/Allergies Concern(s)" outlined persistent-hint
                                    placeholder="Please provide any food allergies or important information concerning your health">
                                </v-textarea>
                            </v-col>
                        </v-row>
                        <v-card-subtitle class="px-0">
                            <v-icon :color="kingsGold" left>mdi-calendar-remove</v-icon>Need To Miss Training On Certain
                            Day(s)
                            <br>
                            If there are certain training days that you need to miss, please provide us the dates and
                            reasoning.
                        </v-card-subtitle>
                        <v-btn class="white--text" :color="primaryColor"
                            @click="openAddTrainingDayMissedDialogDialog()">
                            <v-icon left small>mdi-calendar-plus</v-icon> Add
                        </v-btn>
                        <v-list v-if="trainingDaysMissed.length > 0">
                            <v-list-item v-for="(item,i) in trainingDaysMissed" :key="i">
                                <v-list-item-icon>
                                    <v-icon :color="dangerColor">mdi-calendar-alert</v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-title>{{ item.date }}</v-list-item-title>
                                    <v-list-item-subtitle>{{ item.reason }}</v-list-item-subtitle>
                                </v-list-item-content>
                                <v-list-item-action>
                                    <v-btn :color="dangerColor" class="white--text" @click="removeTrainingDayMissed(i)"
                                        small>
                                        <v-icon left small>mdi-calendar-remove</v-icon> Remove
                                    </v-btn>
                                </v-list-item-action>
                            </v-list-item>
                        </v-list>
                        <v-card-subtitle class="pb-1 px-0">
                            <v-icon :color="kingsGold" left>mdi-tshirt-crew</v-icon>You will receive an RA shirt
                        </v-card-subtitle>
                        <v-radio-group v-model="applicant.shirtSize" label="Shirt size" required
                            :rules="shirtSizeRules">
                            <v-radio v-for="(item, index) in shirtSizeItems" :key="index" :label="item.text"
                                :value="item.value"></v-radio>
                        </v-radio-group>
                        <v-radio-group v-model="applicant.shirtStyle" class="mt-4" label="Shirt style" required
                            :rules="shirtStyleRules">
                            <v-radio v-for="(item, index) in shirtStyleItems" :key="index" :label="item.text"
                                :value="item.value"></v-radio>
                        </v-radio-group>
                        <v-text-field v-model="applicant.shirtDescription" label="Name to appear on the shirt"
                            :rules="shirtDescriptionRules" required>
                        </v-text-field>
                        <!-- <v-card-subtitle v-if="!photo" class="px-0">
                            <v-icon :color="kingsGold" left>mdi-upload</v-icon>Upload Photo - Your photo must be a passport style/portrait (head and shoulders) of <b>only yourself</b>, and in <b>JPEG</b> format.
                            <br><br>
                            <div class="font-weight-bold">Privacy Statement</div>
                            King's endeavours to protect the personal information of its students. King's only collects
                            information (including a photo) that is required for its programs and activites of its
                            students. For more information, please contact our Privacy Officer
                            at <a href="mailto:privacy@kings.uwo.ca">Privacy@kings.uwo.ca</a>.
                            <br><br>
                            <div class="font-weight-bold">Photo Guidelines</div>
                            Read the <a
                                href="https://www.kings.uwo.ca/future-students/admissions/application-process/photo-uploader-instructions/"
                                target="_blank">detailed instructions</a> on how to use the Photo Upload Service.
                            <br>
                            <ul>
                                <li>
                                    The photo must be a portrait photograph.
                                </li>
                                <li>
                                    The photo file cannot exceed <b>5 Megabytes</b> in size. Files larger than this
                                    limitation will not upload.
                                </li>
                                <li>
                                    The photo file must be in <b>JPEG</b> format.
                                </li>
                            </ul>
                        </v-card-subtitle>
                        <v-row v-if="!photo">
                            <v-col cols="12">
                                <v-text-field v-model="photoUpload" :color="getPhotoUploadColor"
                                    label="Photo Upload Status" placeholder="A photo has not been uploaded"
                                    :prepend-icon="getPhotoUploadIcon" readonly required :rules="photoUploadRules">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12">
                                <v-btn class="white--text" :color="infoColor" @click="openPhotoUploadDialog()">
                                    <v-icon left>mdi-cloud-upload</v-icon>Upload Photo
                                </v-btn>
                                <v-dialog v-model="photoUploadDialog" width="576">
                                    <v-card>
                                        <v-card-title>
                                            Upload Photo
                                        </v-card-title>
                                        <v-card-text>
                                            <v-row>
                                                <v-col cols="12" class="text-center">
                                                    <v-avatar v-if="!photoUploadSelect" class="profile"
                                                        :color="secondaryColor" size="256" tile>
                                                        <v-icon class="mx-auto my-auto" :color="infoColor" size="64">
                                                            mdi-image-plus</v-icon>
                                                    </v-avatar>
                                                    <v-avatar v-else class="profile" size="256" tile>
                                                        <v-img ref="previewImage" src=""></v-img>
                                                    </v-avatar>
                                                </v-col>
                                                <v-col cols="12">
                                                    <v-form ref="photoUploadForm" v-model="validPhotoUpload"
                                                        lazy-validation>
                                                        <v-file-input v-model="photoUploadSelect" accept="image/jpeg"
                                                            clearable="false" :color="successColor"
                                                            hint="The photo must be: a portrait photograph, in JPEG format and cannot exceed 5 Megabytes in size."
                                                            label="Upload A Photo" persistent-hint
                                                            :rules="photoUploadSelectRules" show-size
                                                            @change="setPreviewImage" type="file">
                                                        </v-file-input>
                                                    </v-form>
                                                </v-col>
                                            </v-row>
                                        </v-card-text>
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn ref="uploadBtn" class="white--text" :color="successColor"
                                                @click="uploadPhoto" :disabled="!validPhotoUpload">Upload
                                            </v-btn>
                                            <v-btn :color="warningColor" @click="closePhotoUploadDialog">Cancel</v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                            </v-col>
                        </v-row> -->
                    </v-container>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer>
                </v-spacer>
                <v-btn class="white--text" :color="successColor" :disabled="!valid" @click="nextStep(6)">
                    Next
                </v-btn>
                <v-btn class="white--text" :color="kingsGrey" @click="prevStep(4)">
                    Previous
                </v-btn>
            </v-card-actions>
        </v-card>
        <v-dialog v-model="trainingDayMissedDialog" width="540">
            <v-card>
                <v-card-title>
                    Add Training Day Missed
                </v-card-title>
                <v-card-text>
                    <v-form ref="trainingDayMissedForm" v-model="validTrainingDayMissed" lazy-validation>
                        <v-menu ref="date" v-model="dateMenu" :close-on-content-click="false"
                            transition="scale-transition" offset-y max-width="290px" min-width="290px">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field v-model="trainingDayMissed.date" id="date" label="Date" name="date"
                                    placeholder="Please select a date..." prepend-icon="mdi-calendar" readonly
                                    :rules="dateRules" v-bind="attrs" v-on="on">
                                </v-text-field>
                            </template>
                            <v-date-picker v-model="trainingDayMissed.date" no-title @input="dateMenu = false">
                            </v-date-picker>
                        </v-menu>
                        <v-textarea v-model="trainingDayMissed.reason" auto-grow hide-details label="Reason" outlined
                            persistent-hint required :rules="reasonRules">
                        </v-textarea>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn :color="successColor" :disabled="!validTrainingDayMissed" text
                        @click="addTrainingDayMissed()">
                        Add
                    </v-btn>
                    <v-btn :color="warningColor" text @click="closeAddTrainingDayMissedDialogDialog()">
                        Cancel
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
    name: 'residence-assistant-general-information-form',
    props: {
        applicant: {
            required: true
        },
        photo: {
            required: true,
            type: Boolean
        }
    },
    data() {
        return {
            alert: false,
            dateMenu: false,
            dateRules: [
                v => !!v || 'Date is required',
            ],
            firstAidTrainingInitialsRules: [
                v => !!v || 'Initials is required',
                v => (v && v.length >= 2) || 'Initials must be more atleast 2 characters'
            ],
            photoUpload: '',
            photoUploadDialog: false,
            photoUploadRules: [
                v => !!v || 'A valid photo must be uploaded'
            ],
            photoUploadSelect: '',
            photoUploadSelectRules: [
                v => (!v && v.size > 0) || v.size < 5000000 || 'Please select a valid photo within the specified requirements'
            ],
            reasonRules: [
                v => !!v || 'Reason is required',
                v => (v && v.length >= 2) || 'Please provide a valid reason'
            ],
            shirtSizeItems: [{
                    text: 'XS',
                    value: 'XS'
                },
                {
                    text: 'S',
                    value: 'S'
                }, {
                    text: 'M',
                    value: 'M'
                },
                {
                    text: 'LG',
                    value: 'LG'
                },
                {
                    text: 'XL',
                    value: 'XL'
                },
                {
                    text: 'XXL',
                    value: 'XXL'
                }
            ],
            shirtSizeRules: [
                v => !!v || 'Shirt size is required'
            ],
            shirtStyleItems: [{
                    text: `Men's style`,
                    value: 'M'
                },
                {
                    text: 'Ladies style',
                    value: 'F'
                }
            ],
            shirtStyleRules: [
                v => !!v || 'Shirt style is required'
            ],
            shirtDescriptionRules: [
                v => !!v || 'Shirt name is required',
                v => (v && v.length >= 1) || 'Shirt name must be more atleast 1 characters'
            ],
            sinCardInitialsRules: [
                v => !!v || 'Initials is required',
                v => (v && v.length >= 2) || 'Initials must be more atleast 2 characters'
            ],
            trainingDayMissed: {
                date: '',
                reason: ''
            },
            trainingDayMissedDialog: false,
            trainingDaysMissed: [],
            valid: true,
            validTrainingDayMissed: true,
            validPhotoUpload: true
        }
    },
    methods: {
        addTrainingDayMissed() {
            if (this.$refs.trainingDayMissedForm.validate()) {
                this.$emit('addTrainingDayMissed', this.trainingDayMissed);
                this.trainingDaysMissed = this.applicant.trainingDaysMissed;
                this.closeAddTrainingDayMissedDialogDialog();
            }
        },
        closeAddTrainingDayMissedDialogDialog() {
            this.trainingDayMissedDialog = false;
        },
        closePhotoUploadDialog() {
            this.photoUploadDialog = false;
        },
        openAddTrainingDayMissedDialogDialog() {
            this.trainingDayMissed = {
                date: '',
                reason: ''
            };

            if (this.$refs.trainingDayMissedForm) {
                this.$refs.trainingDayMissedForm.resetValidation();
            }

            this.trainingDayMissedDialog = true;
        },
        openPhotoUploadDialog() {
            this.photoUploadDialog = true;
            this.setPreviewImage();
        },
        nextStep(val) {
            if (this.$refs.placementPreferenceForm.validate()) {
                this.alert = false;
                this.$emit('setStep', val);
                this.$nextTick(() => {
                    this.$emit('scrollToTop');
                })
            } else {
                this.alert = true;
                this.$emit('scrollToTop');
            }
        },
        prevStep(val) {
            this.$emit('setStep', val);
            this.$nextTick(() => {
                this.$emit('scrollToTop');
            })
        },
        removeTrainingDayMissed(index) {
            this.$emit('removeTrainingDayMissed', index);
            this.trainingDaysMissed = this.applicant.trainingDaysMissed;
        },
        setPreviewImage() {
            const that = this;
            const reader = new FileReader();

            // Event listener
            reader.addEventListener("load", function () {
                /* eslint-disable-next-line */
                that.$refs.previewImage.src = reader.result;
            }, false);

            // Read file
            if (this.photoUploadSelect) {
                reader.readAsDataURL(this.photoUploadSelect);
            }
        },
        uploadPhoto() {
            if (this.$refs.photoUploadForm.validate()) {
                const that = this;
                const formData = new FormData();
                let api = `https://${location.hostname}/cgi-bin/snapshot-api/api.pl`;

                // Parse array into string
                formData.append('mode', 'upload');
                formData.append('formParamNameImage', 'image');
                formData.append('image', this.photoUploadSelect);
                formData.append('origin', 'res-app');

                // Loading icon
                this.$refs.uploadBtn.loading = true;

                // Post request
                fetch(api, {
                        method: 'POST',
                        body: formData
                    })
                    .then(function (response) {
                        // Return JSON response
                        return response.json();
                    })
                    .then(function (json) {
                        that.$refs.uploadBtn.loading = false;

                        // Error handling
                        if (json.result.match(/OK/i)) {
                            that.$emit('setNotification', '#1dc9b7', 'mdi-check-circle', `Your photo has been successfully uploaded.`, true);
                            that.photoUpload = "Success";
                            that.closePhotoUploadDialog();
                        } else {
                            that.$emit('setNotification', '#ffb822', 'mdi-alert-circle', `Your photo could not be uploaded. ${json.message}`, true);
                            that.photoUpload = '';
                        }
                    })
                    .catch(function () {
                        that.$refs.uploadBtn.loading = false;
                        that.$emit('setNotification', '#f64e60', 'mdi-alert-outline', `An error occurred. Please contact your system administrator.`, true);
                        that.photoUpload = '';
                    });
            }
        }
    },
    computed: {
        dangerColor() {
            return '#f64e60';
        },
        getPhotoUploadColor() {
            if (this.photoUpload == "Success") {
                return '#1bc5bd';
            }

            return '#f64e60';
        },
        getPhotoUploadIcon() {
            if (this.photoUpload == "Success") {
                return 'mdi-check';
            }

            return 'mdi-alert';
        },
        infoColor() {
            return '#5578eb';
        },
        kingsGold() {
            return '#d7ae28';
        },
        kingsGrey() {
            return '#6d6e71';
        },
        primaryColor() {
            return '#3699ff';
        },
        secondaryColor() {
            return '#f9f9fc';
        },
        successColor() {
            return '#1bc5bd';
        },
        warningColor() {
            return '#ffb822'
        }
    }
}
</script>

<style scoped>
.v-input--checkbox,
.v-input--radio-group {
    margin-top: 0 !important;
}
</style>